module.exports = __webpack_public_path__ + "static/media/October_2026_1.697e79b3.webp";